<template>
  <div>
    <div class="section_quick">
      <div class="title_quick">
        <p>Estadistica</p>
      </div>
      <div class="ctn_quick">
        <p>--</p>
      </div>
    </div>
    <div class="section_quick">
      <div class="title_quick">
        <p>Acceso rápido</p>
      </div>
      <div class="ctn_quick">
        <p>--</p>
      </div>
    </div>
    <DeleteOrder :datos="delItem" :visible="showDel" @close="showDel = false" />
    <EditOrder
      :datos="editedItem"
      :visible="showEdit"
      @close="showEdit = false"
    />
    <NewOrder :visible="showNew" @close="showNew = false" />
    <!-- nueva categoria -->
    <div class="ctn_new">
      <v-btn outlined @click.stop="showNew = true" color="primary">
        <v-icon>add</v-icon>Agregar pedido
      </v-btn>
    </div>
    <v-card class="no-shadow">
      <v-card-title class="ctn_search">
        Listado de pedidos
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="getCategoryList"
        :search="search"
      >
        <template v-slot:item.name="{ item }">
          <v-icon>mdi-store-outline</v-icon>
          {{ item.name }}
        </template>
        <template v-slot:item.state="{ item }">
          <div class="lb lb_activo" v-if="item.state === true">Activo</div>
          <div class="lb lb_inactivo" v-else>Inactivo</div>
        </template>

        <template v-slot:item.updateAt="{ item }">{{
          item.updateAt | formatDate
        }}</template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="editItem(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon class="delete_space" @click="deleteItem(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import NewOrder from '@/components/order/NewOrder.vue';
import EditOrder from '@/components/order/EditOrder.vue';
import DeleteOrder from '@/components/order/DeleteOrder.vue';

export default {
  name: 'ListCategory',
  components: {
    NewOrder,
    EditOrder,
    DeleteOrder,
  },
  data() {
    return {
      search: '',
      showEdit: false,
      showDel: false,
      showNew: false,
      delItem: {},
      editedItem: {},
      //editedIndex: -1,
      headers: [
        {
          text: 'Nombre de la categoria',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Tienda', value: 'shop.name_shop' },
        { text: 'Estado', value: 'state' },

        { text: 'Ultima modificación', value: 'updateAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  mounted() {
    this.listCategory();
  },
  methods: {
    ...mapActions(['listCategory']),

    editItem(param) {
      this.editedItem = Object.assign({}, param);
      this.showEdit = true;
      //console.log(param)
    },
    deleteItem(param) {
      this.delItem = Object.assign({}, param);
      this.showDel = true;
      //console.log(param)
    },
  },
  computed: {
    ...mapGetters(['getCategoryList']),
  },
  filters: {
    formatDateShort: (value) => {
      if (value) {
        return moment(value).format('LL');
      }
      return '-';
    },
    formatDate: (value) => {
      if (value) {
        return moment(value).format('LLL');
      }
      return '-';
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/base.scss';
.no-shadow {
  box-shadow: none !important;
  background: transparent !important;
}
.ctn_search {
  background-color: $bg-box-search;
  border-radius: 20px !important;
  margin-bottom: 25px;
}
.ctn_new {
  margin-bottom: 20px;
  button.v-btn {
    color: $color-grey-dash !important;
    background-color: #fff !important;
    border: 1px solid #ddd;
    border-radius: 30px;
    height: 48px !important;
    //width: 180px;
    //min-width: 200px;
    overflow: hidden;
    font-size: 0.8rem;
    //box-shadow: $shadow-1 !important;
    &:hover {
      box-shadow: $shadow-1 !important;
    }
    span.v-btn__content {
      i {
        font-size: 28px;
        color: $bg-color-500;
      }
    }
  }
}
.delete_space {
  margin-left: 30px;
}
</style>
